// extracted by mini-css-extract-plugin
module.exports = {"resultAnswersDistributionContainer":"AnswersDistribution_resultAnswersDistributionContainer__1zGAk","disclaimer":"AnswersDistribution_disclaimer__1MjzZ"};